import { render, staticRenderFns } from "./star-rating.vue?vue&type=template&id=155dda4b&"
import script from "./star-rating.vue?vue&type=script&lang=js&"
export * from "./star-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155dda4b')) {
      api.createRecord('155dda4b', component.options)
    } else {
      api.reload('155dda4b', component.options)
    }
    module.hot.accept("./star-rating.vue?vue&type=template&id=155dda4b&", function () {
      api.rerender('155dda4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hgd6SS4GrFt2/JS/comp/star-rating.vue"
export default component.exports